import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

const getIcon = (idx) => `https://p1.liveauctioneers.com/dist/images/icon${idx}.png`;

type Props = {
    sellerName: string;
};

export const SendSellerConsignmentMessageReasons = ({ sellerName }: Props) => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className="text-black flex h-[147px] w-full flex-col bg-surface-100 p-md text-center">
            <BodyPrimary className="pb-sm text-base leading-[1.38]">
                {formatMessage(['why_consign_with'], { values: { sellerName } })}
            </BodyPrimary>
            <div className="flex justify-around text-xs">
                <div className="flex w-[142px] flex-col items-center tracking-[0.5px]">
                    <img
                        className="h-[35px] pb-xs"
                        src={getIcon(2)}
                    />
                    {formatMessage(['licensed_auctioneer'])}
                </div>
                <div className="flex w-[142px] flex-col items-center tracking-[0.5px]">
                    <img
                        className="h-[35px] pb-xs"
                        src={getIcon(1)}
                    />
                    {formatMessage(['reach_millions'])}
                </div>
                <div className="flex w-[142px] flex-col items-center tracking-[0.5px]">
                    <img
                        className="h-[35px] pb-xs"
                        src={getIcon(3)}
                    />
                    {formatMessage(['discover_the_value'])}
                </div>
            </div>
        </div>
    );
};
